import { AppGlobals } from '../AppGlobals';
import { IApp03ProjectType } from '../types';
import { EntityService } from './EntityService';

export class App03ProjectTypeService extends EntityService<IApp03ProjectType> {
    constructor() {
        super(`/App03ProjectTypes`);
    }

    public readAllForLookup(additionalFields?: string): Promise<IApp03ProjectType[]> {
        return this.readAll(
            `?$select=ID,Title${additionalFields ? `,${additionalFields}` : ''}`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
        );
    }

}